import * as Types from '../../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type CreateMakeToOrderPlanMutationVariables = Types.Exact<{
  input: Types.CreateMakeToOrderPlanInput;
}>;


export type CreateMakeToOrderPlanMutation = { __typename?: 'Mutation', createMakeToOrderPlan: { __typename?: 'CreateMakeToOrderPlanPayload', containers?: number | null, eachesReserved?: number | null, eachesPerUnit?: number | null, productionLot?: { __typename?: 'ProductionLotStateData', productionLotId: string, productionPlanId: string, lotNumber: number, quantity: number, finishJob: { __typename?: 'ProductionJobData', productionJobId: string, jobNumber: number, weekReadyDate: Types.TDateISO } } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type CreateMakeToOrderPlanForLinesMutationVariables = Types.Exact<{
  input: Types.CreateMakeToOrderPlanForLinesInput;
}>;


export type CreateMakeToOrderPlanForLinesMutation = { __typename?: 'Mutation', createMakeToOrderPlanForLines: { __typename?: 'CreateMakeToOrderPlanForLinesPayload', productionLotId?: string | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const CreateMakeToOrderPlanDocument = new TypedDocumentString(`
    mutation CreateMakeToOrderPlan($input: CreateMakeToOrderPlanInput!) {
  createMakeToOrderPlan(input: $input) {
    productionLot {
      ...ProductionLotCreatedFragment
    }
    containers
    eachesReserved
    eachesPerUnit
    errors {
      code
      message
    }
  }
}
    fragment ProductionLotCreatedFragment on ProductionLotStateData {
  productionLotId
  productionPlanId
  lotNumber
  quantity
  finishJob {
    productionJobId
    jobNumber
    weekReadyDate
  }
}`);
export const CreateMakeToOrderPlanForLinesDocument = new TypedDocumentString(`
    mutation CreateMakeToOrderPlanForLines($input: CreateMakeToOrderPlanForLinesInput!) {
  createMakeToOrderPlanForLines(input: $input) {
    productionLotId
    errors {
      code
      message
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    CreateMakeToOrderPlan: build.mutation<CreateMakeToOrderPlanMutation, CreateMakeToOrderPlanMutationVariables>({
      query: (variables) => ({ document: CreateMakeToOrderPlanDocument, variables })
    }),
    CreateMakeToOrderPlanForLines: build.mutation<CreateMakeToOrderPlanForLinesMutation, CreateMakeToOrderPlanForLinesMutationVariables>({
      query: (variables) => ({ document: CreateMakeToOrderPlanForLinesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useCreateMakeToOrderPlanMutation, useCreateMakeToOrderPlanForLinesMutation } = injectedRtkApi;
